<template>
  <v-card flat style="margin-top: 4px">
    <div class="btn-carusel_label">{{ label }}:</div>
    <v-chip class="btn-carusel_wrap">
      <v-tooltip bottom color="secondary">
        <template v-slot:activator="{ on, attrs }">
          <div
            class="btn-carusel_left"
            v-bind="attrs"
            v-on="on"
            @click="setPrevVal"
            @mouseover="hover('left')"
            @mouseleave="unHover"
          ></div>
        </template>
        <span>{{ prevVal }}</span>
      </v-tooltip>

      <v-tooltip bottom color="secondary">
        <template v-slot:activator="{ on, attrs }">
          <div
            class="btn-carusel_right"
            v-bind="attrs"
            v-on="on"
            @click="setNextVal"
            @mouseover="hover('right')"
            @mouseleave="unHover"
          ></div>
        </template>
        <span>{{ nextVal }}</span>
      </v-tooltip>

      <div
        class="btn-carusel_content"
        id="carusel_content"
        :style="{ left: contentPos + 'px' }"
        :class="{ clicked: fade }"
      >
        {{ currentVal }}
      </div>
      <div
        id="progress"
        :style="{ width: progressBarWidth + '%', left: progressBarPos + '%' }"
      ></div>
    </v-chip>
  </v-card>
</template>


<script>
import { requiredRule } from "~/plugins/rules";
import moment from "moment";

export default {
  props: {
    type: {
      default: "month",
    },
    label: {
      default: "Месяц",
    },
    items: {
      type: Array,
      default: function () {
        return ["Текущий", "Предыдущий"];
      },
    },
    getVal: {
      type: Function,
    },
  },
  data() {
    return {
      formRules: {
        required: requiredRule,
      },
      arr: [],
      curr: 0,
      contentPos: 0,
      fade: false,
      progressBarWidth: 100 / this.items.length,
      progressBarPos: 0,
    };
  },
  methods: {
    setNextVal() {
      this.fade = true;
      this.contentPos = -50;
      setTimeout(() => {
        this.fade = false;
        this.contentPos = 0;
      }, 150);

      if (this.curr + 1 === this.arr.length) {
        this.curr = 0;
        this.progressBarPos = 0;
      } else {
        this.curr++;
        this.progressBarPos += 100 / this.arr.length;
      }

      this.getVal(this.answer());
    },

    setPrevVal() {
      this.fade = true;
      this.contentPos = 50;
      setTimeout(() => {
        this.fade = false;
        this.contentPos = 0;
      }, 150);

      if (this.curr - 1 < 0) {
        this.curr = this.arr.length - 1;
        this.progressBarPos = (100 / this.arr.length) * (this.arr.length - 1);
      } else {
        this.curr--;
        this.progressBarPos -= 100 / this.arr.length;
      }
      this.getVal(this.answer());
    },

    // Проверка типа селектора
    answer() {
      switch (this.type) {
        case "month":
          if (this.currentVal === "Текущий") {
            return {
              start: moment().startOf("month").startOf("day").toDate(),
              end: moment().endOf("month").endOf("day").toDate(),
            };
          } else if (this.currentVal === "Предыдущий") {
            return {
              start: moment()
                .subtract(1, "month")
                .startOf("month")
                .startOf("day")
                .toDate(),
              end: moment()
                .subtract(1, "month")
                .endOf("month")
                .endOf("day")
                .toDate(),
            };
          }
          break;

        case "general":
          if (this.items) return this.items[this.curr].id;
          break;
      }
    },

    typeOffs() {
      switch (this.type) {
        case "month":
          this.arr = this.items;
          break;

        case "general":
          this.arr = this.items.map((value) => value.name);
          break;
      }
    },

    hover(x) {
      x === "left" ? (this.contentPos = 3) : (this.contentPos = -3);
    },
    unHover() {
      this.contentPos = 0;
    },
  },

  computed: {
    currentVal: function () {
      return this.arr[this.curr];
    },
    prevVal: function () {
      if (this.curr === 0) return this.arr[this.arr.length - 1];
      else return this.arr[this.curr - 1];
    },
    nextVal: function () {
      if (this.curr + 1 >= this.arr.length) return this.arr[0];
      else return this.arr[this.curr + 1];
    },
  },
  mounted() {
    this.typeOffs();
    if (this.items.length > 0) this.getVal(this.answer());
  },
  watch: {
    items(newVal) {
      if (newVal.length > 0) {
        this.typeOffs();
        this.getVal(this.answer());
        if (this.progressBarWidth === Infinity)
          this.progressBarWidth = 100 / this.items.length;
      }
    },
  },
};
</script>

<style scoped>
.btn-carusel_label {
  display: inline-block;
  min-width: 115px;
  text-align: end;
  margin-right: 10px;
  user-select: none;
  font-size: 1rem;
}
.btn-carusel_wrap {
  position: relative;
  display: inline-block;
  padding: 0;
  width: 50%;
  border-radius: 5px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
#progress {
  position: absolute;
  top: 0;
  height: 3px;
  background-color: #1a995e99;
  transition: all ease 150ms;
  pointer-events: none;
}
.btn-carusel_left:hover,
.btn-carusel_right:hover {
  background-color: #6bad7a;
}
.btn-carusel_left:active,
.btn-carusel_right:active {
  box-shadow: inset 0 0 5px 1px #226e33;
}
.btn-carusel_left,
.btn-carusel_right {
  position: absolute;
  height: 100%;
  cursor: pointer;
}
.btn-carusel_left {
  left: 0;
  width: 25%;
}
.btn-carusel_right {
  right: 0;
  width: 75%;
}
.btn-carusel_left::after {
  content: "";
  position: absolute;
  right: 0;
  display: block;
  width: 1px;
  height: 100%;
  background-color: #6bad7a14;
}
.btn-carusel_content {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  font-size: 1rem;
  text-align: center;
  padding-top: 0.3rem;
  user-select: none;
  transition: all ease 200ms;
}
.btn-carusel_left:hover #carusel_content {
  left: -5px;
}
.clicked {
  animation-name: fade;
  animation-duration: 150ms;
}
@keyframes fade {
  0% {
    opacity: 100%;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 100%;
  }
}
</style>